import {
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import type { DrawerMode } from "../types";

interface EditAddressDrawerFooterProps {
  mode: DrawerMode;
  isSaving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

export default function EditAddressDrawerFooter({
  mode,
  isSaving,
  onSave,
  onCancel,
}: Readonly<EditAddressDrawerFooterProps>) {
  if (mode === "read-only") return null;

  return (
    <Box
      sx={{
        borderTop: 1,
        borderColor: "divider",
        px: 2.5,
        py: 1.5,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexShrink: 0,
        bgcolor: "background.paper",
      }}
    >
      <Button onClick={onCancel} color="inherit" sx={{ color: "text.secondary" }}>
        Cancel
      </Button>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaving}
          startIcon={
            isSaving ? <CircularProgress size={16} color="inherit" /> : undefined
          }
        >
          {mode === "create" ? "Create Address" : "Save Changes"}
        </Button>
      </Box>
    </Box>
  );
}
